export default __webpack_public_path__ + "images/logo-black_d99acd.svg";